/**
 * IME Addendum module.
@module molecues/addendums
 */
export default function imeAddendums() {

	const $ = jQuery;
	const $newAddendumFile = $( '.new-addendum-file' );
	const $deleteAddendumFile = $( '.delete-addendum-file' );
	const $updateAddendumFile = $( '.update-addendum-file' );
	const $deleteAddendum = $( '.delete-addendum' );
	const $trashAddendum = $( '.trash-addendum' );
	const $modelDataRow = '.m__modal-content__addendum__all-data-row-file';
	const $editAddendumTitle = $( '.edit-addendum-title' );
	const currentLocation = window.location.origin;

	$newAddendumFile.on( 'change', newAddendumFile );
	$updateAddendumFile.on( 'change', updateAddendum );
	$deleteAddendumFile.on( 'click', deleteAddendumFile );
	$trashAddendum.on( 'click', trashAddendum );
	$deleteAddendum.on( 'click', deleteAddendum );
	$editAddendumTitle.on( 'click', editAddendumTitle );

	/**
	 * Edit an addendum button event function
	 * @param {object} e - Event object.
	 */
	function editAddendumTitle( e ) {
		e.preventDefault();
		const addendumID = $( this ).data( 'addendum-id' );
		const $oldTitle = $( `#addendum-title-${addendumID}` ).html();
		/*eslint-disable */
		var title = prompt( 'Please enter the new addendum title:', $oldTitle );
		/*eslint-enable */
		if ( title !== null && title !== '' ) {
			const fd = new FormData();

			fd.append( 'action', 'addendums' );
			fd.append( 'option', 'editAddendumTitle' );
			fd.append( 'addendum_id', addendumID );
			fd.append( 'addendum_title', title );

			$.ajax({
				type: 'POST',
				url : `${currentLocation}/wp-admin/admin-ajax.php`,
				data: fd,
				contentType: false,
				processData: false,
				success: function() {
					$( `#addendum-title-${addendumID}` ).text( title );
				}
			});
		}
	}

	/**
	 * Add new addendum file.
	 * @param {object} e - Event object.
	 */
	function newAddendumFile( e ) {
		e.preventDefault();

		const fd = new FormData();
		const file = $( this );
		const individualFile = file[0].files[0];
		const addendumID = file.data( 'addendum-id' );

		fd.append( 'action', 'addendums' );
		fd.append( 'option', 'new' );
		fd.append( 'file', individualFile );
		fd.append( 'addendum_id', addendumID );

		$.ajax({
			type: 'POST',
			url : `${currentLocation}/wp-admin/admin-ajax.php`,
			data: fd,
			contentType: false,
			processData: false,
			success: function( response ) {
				const fileName = response.file_url.split( '/' );
				file.closest( $modelDataRow ).html(
				`<a class="addendum-file-link" href="${response.file_url}" ` +
				`target="_blank" style="font-weight:700">${fileName[ fileName.length - 1 ]}</a>` +
				'<div>New file uploaded correctly</div>'
				);
			}
		});
	}

	/**
	 * Trash addendum.
	 * @param {object} e - Event object.
	 */
	function trashAddendum( e ) {
		e.preventDefault();

		const fd = new FormData();
		const addendumID = $( e.target ).data( 'addendum-id' );
		const addendumTitle = $( e.target ).data( 'addendum-title' );
		/*eslint-disable */
		var r = confirm( `Are you sure you'd like to delete '${addendumTitle}'?` );
		/*eslint-enable */
		fd.append( 'action', 'addendums' );
		fd.append( 'addendum_id', addendumID );
		fd.append( 'option', 'trashAddendum' );

		if ( r === true ) {
			$.ajax({
				type: 'POST',
				url : `${currentLocation}/wp-admin/admin-ajax.php`,
				data: fd,
				contentType: false,
				processData: false,
				success: function() {
					$( e.target ).parent().text( `Addendum '${addendumTitle}'has been sent to Trash!` );
				}
			});
		}
	}
	
	/**
	 * Delete addendum.
	 * @param {object} e - Event object.
	 */
	function deleteAddendum( e ) {
		e.preventDefault();

		const fd = new FormData();
		const addendumID = $( e.target ).data( 'addendum-id' );
		/*eslint-disable */
		var r = confirm( 'Are you sure you want to delete this Addendum?' );
		/*eslint-enable */
		fd.append( 'action', 'addendums' );
		fd.append( 'addendum_id', addendumID );
		fd.append( 'option', 'deleteAddendum' );

		if ( r === true ) {
			$.ajax({
				type: 'POST',
				url : `${currentLocation}/wp-admin/admin-ajax.php`,
				data: fd,
				contentType: false,
				processData: false,
				success: function() {
					$( e.target ).parent().text( 'Addendum deleted' );
				}
			});
		}
	}

	/**
	 * Update addendum file.
	 * @param {object} e - Event object.
	 */
	function updateAddendum( e ) {
		e.preventDefault();

		const fd = new FormData();
		const $this = $( this );
		const file = $updateAddendumFile;
		const individualFile = file[0].files[0];
		const fileName = $this.data( 'filename' );
		const addendumID = $( e.target ).data( 'addendum-id' );

		fd.append( 'file', individualFile );
		fd.append( 'action', 'addendums' );
		fd.append( 'file_name', fileName );
		fd.append( 'addendum_id', addendumID );
		fd.append( 'option', 'update' );

		$.ajax({
			type: 'POST',
			url : `${currentLocation}/wp-admin/admin-ajax.php`,
			data: fd,
			contentType: false,
			processData: false,
			success: function( response ) {
				const newFileName = response.file_url.split( '/' );

				$( '.addendum-file-link' ).text( newFileName[ newFileName.length - 1 ]);
				$( '.addendum-file-link' ).attr( 'href', response.file_url );

				$( '.update-addendum-file-wrapper' ).text( 'File updated correctly' );
				$( '.delete-addendum-file' ).remove();
			}
		});
	}

	/**
	 * Delete addendum file.
	 * @param {object} e - Event object.
	 */
	function deleteAddendumFile( e ) {
		e.preventDefault();

		const deleteBtn = $( this );
		const fileName = deleteBtn.data( 'filename' );
		const fileURL = deleteBtn.data( 'fileurl' );
		const addendumID = deleteBtn.data( 'addendum-id' );
		/*eslint-disable */
		var r = confirm( `Are you sure you want to delete the file '${fileName}'?` );
		/*eslint-enable */
		const newAddendumID = `#new-addendum-${addendumID}`;

		if ( r === true ) {
			$.ajax({
				type : 'post',
				url : `${currentLocation}/wp-admin/admin-ajax.php`,
				data : {
					action: 'addendums',
					option: 'deleteAddendumFile',
					addendum_id: addendumID,
					file_name: fileName,
					file_url: fileURL
				},
				success: function() {
					$( newAddendumID ).removeAttr( 'style' );
					deleteBtn.closest( $modelDataRow ).text( 'File deleted' );
				}
			});
		}
	}

}
